module.exports = __webpack_public_path__ + "static/media/ryanashleypic.56e2df13.png";